import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import styles from '../../styles/ITTicketPage.module.css';
 
const API = 'https://api-backend.full-trucking-service.com/api';
 
const CATEGORIES = [
  'Login / Authentication','Billing & Payments','Dispatcher Module',
  'Drivers & Trucks','Loads & Freight','Reports & Exports',
  'Notifications','Account Settings','Performance / Speed',
  'AI Features','Mobile App','Other',
];
const AREAS = ['Web App','Mobile App','API / Integrations','Email Notifications','All Platforms'];
const PRIORITIES = [
  { key:'low',      label:'Low',      color:'#10b981' },
  { key:'medium',   label:'Medium',   color:'#f59e0b' },
  { key:'high',     label:'High',     color:'#f97316' },
  { key:'critical', label:'Critical', color:'#ef4444' },
];
const STATUS_META = {
  open:        { label:'Open',        color:'#3b82f6' },
  in_progress: { label:'In Progress', color:'#f59e0b' },
  resolved:    { label:'Resolved',    color:'#10b981' },
  closed:      { label:'Closed',      color:'#555'    },
};
const PRIORITY_COLOR = { low:'#10b981', medium:'#f59e0b', high:'#f97316', critical:'#ef4444' };
 
const TAB = { NEW:'new', MY:'my' };
 
const ITTicketPage = () => {
  const token  = sessionStorage.getItem('token');
  const config = { headers: { Authorization:`Bearer ${token}` } };
  const [theme] = useState(() => sessionStorage.getItem('theme') || localStorage.getItem('theme') || 'dark');
 
  const [activeTab, setActiveTab] = useState(TAB.NEW);
 
  // client
  const [clientId,       setClientId]       = useState('');
  const [customerNumber, setCustomerNumber] = useState('');
  const [companyName,    setCompanyName]    = useState('');
  const [contactName,    setContactName]    = useState('');
  const [contactEmail,   setContactEmail]   = useState('');
  const [loadingClient,  setLoadingClient]  = useState(true);
 
  // form
  const [subject,     setSubject]     = useState('');
  const [category,    setCategory]    = useState('');
  const [area,        setArea]        = useState('');
  const [description, setDescription] = useState('');
  const [priority,    setPriority]    = useState('low');
  const [attachments, setAttachments] = useState([]);
  const [submitting,  setSubmitting]  = useState(false);
  const [submitted,   setSubmitted]   = useState(false);
  const [ticketRef,   setTicketRef]   = useState('');
  const [formError,   setFormError]   = useState('');
 const [originalContactName,  setOriginalContactName]  = useState('');
const [originalContactEmail, setOriginalContactEmail] = useState('');
  // my tickets
  const [tickets,        setTickets]        = useState([]);
  const [loadingTickets, setLoadingTickets] = useState(false);
  const [filterStatus,   setFilterStatus]   = useState('');
  const [selectedTicket, setSelectedTicket] = useState(null);
 
  // chat
  const [chatMsg, setChatMsg] = useState('');
  const chatEndRef = useRef(null);
 
  useEffect(() => {
  (async () => {
    try {
      const r1 = await axios.get(`${API}/clients`, config);
      const id = r1.data._id || '';
      setClientId(id);
      setCustomerNumber(r1.data.customerNumber || '—');
      if (id) {
        const r2 = await axios.get(`${API}/clients/${id}`, config);
        const name  = `${r2.data.firstName || ''} ${r2.data.lastName || ''}`.trim();
        const email = r2.data.email || '';
 
        setCompanyName(r2.data.companyName || '—');
        setContactName(name);
        setContactEmail(email);
 
        // ✅ Salvează originalele pentru reset
        setOriginalContactName(name);
        setOriginalContactEmail(email);
      }
    } catch { setClientId('Unavailable'); }
    finally  { setLoadingClient(false); }
  })();
}, []);
 
  // fetch tickets
  const fetchTickets = async (status = '') => {
    setLoadingTickets(true);
    try {
      const params = status ? { status } : {};
      const res    = await axios.get(`${API}/tickets`, { ...config, params });
      setTickets(res.data?.data || []);
    } catch { setTickets([]); }
    finally  { setLoadingTickets(false); }
  };
 
  useEffect(() => {
    if (activeTab === TAB.MY) fetchTickets(filterStatus);
  }, [activeTab, filterStatus]);
 
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior:'smooth' });
  }, [selectedTicket?.notes]);
 
  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError(''); setSubmitting(true);
    try {
      const res = await axios.post(`${API}/tickets`, {
        clientId, customerNumber, companyName, contactName, contactEmail,
        subject, category, area, description, priority,
        attachments: attachments.map(f => f.name),
      }, config);
      setTicketRef(res.data.ticketNumber || '#—');
      setSubmitted(true);
    } catch {
      setFormError('Failed to submit ticket. Please try again.');
    } finally { setSubmitting(false); }
  };
 
const handleReset = () => {
  setSubmitted(false);
  setTicketRef('');
 
  // Form fields — reset complet
  setSubject('');
  setCategory('');
  setArea('');
  setDescription('');
  setPriority('low');
  setAttachments([]);
  setFormError('');
 
  // Contact — restaurează valorile auto-filled originale
  setContactName(originalContactName);
  setContactEmail(originalContactEmail);
};
 
  const handleFiles = (files) => {
    const inc = Array.from(files);
    setAttachments(prev => {
      const names = prev.map(f => f.name);
      return [...prev, ...inc.filter(f => !names.includes(f.name))];
    });
  };
 
  // chat send (client-side only — wire POST /api/tickets/:id/note when ready)
  const handleChatSend = async () => {
    if (!chatMsg.trim() || !selectedTicket) return;
 
    const note = {
      text:     chatMsg.trim(),
      addedBy:  contactName || 'Client',
      addedAt:  new Date().toISOString(),
      isClient: true,
    };
 
    // Optimistic update
    setSelectedTicket(prev => ({
      ...prev,
      notes: [...(prev.notes || []), note],
    }));
    setChatMsg('');
 
    try {
      await axios.post(
        `${API}/tickets/${selectedTicket._id}/note`,
        { text: note.text, addedBy: note.addedBy },
        config
      );
    } catch {
      // Rollback dacă pică
      setSelectedTicket(prev => ({
        ...prev,
        notes: (prev.notes || []).slice(0, -1),
      }));
      setChatMsg(note.text);
    }
  };
 
  const charLeft = 2000 - description.length;
 
  return (
    <div className={`${styles.page} ${theme === 'light' ? styles.pageLight : ''}`}>
 
      {/* Header */}
      <div className={styles.pageHeader}>
        <div>
          <h1 className={styles.pageTitle}>IT Support Ticket</h1>
          <p className={styles.pageSubtitle}>Report issues or track existing tickets — we respond within 24 hours.</p>
        </div>
      </div>
 
      {/* Tabs */}
      <div className={styles.tabs}>
        <button className={`${styles.tab} ${activeTab===TAB.NEW ? styles.tabActive:''}`} onClick={() => setActiveTab(TAB.NEW)}>
          New Ticket
        </button>
        <button className={`${styles.tab} ${activeTab===TAB.MY ? styles.tabActive:''}`}
          onClick={() => { setActiveTab(TAB.MY); fetchTickets(filterStatus); }}>
          My Tickets
          {tickets.length > 0 && <span className={styles.tabBadge}>{tickets.length}</span>}
        </button>
      </div>
 
      {/* ── TAB: NEW TICKET ───────────────────────────────────────────────── */}
      {activeTab === TAB.NEW && (
        <>
          {submitted ? (
            <div className={styles.successWrap}>
              <div className={styles.successIcon}>✓</div>
              <h2 className={styles.successTitle}>Ticket Submitted</h2>
              <p className={styles.successRef}>Your ticket <strong>{ticketRef}</strong> has been created.</p>
              <p className={styles.successNote}>Confirmation sent to <strong>{contactEmail}</strong>.</p>
              <div style={{ display:'flex', gap:'10px', justifyContent:'center', flexWrap:'wrap' }}>
                <button className={styles.btnPrimary} onClick={handleReset}>Submit Another</button>
                <button className={styles.btnCancel} onClick={() => { setActiveTab(TAB.MY); fetchTickets(''); }}>
                  View My Tickets
                </button>
              </div>
            </div>
          ) : (
            <form className={styles.form} onSubmit={handleSubmit}>
 
              {/* Client info */}
              <div className={styles.card}>
                <div className={styles.sectionLabel}>Client Information</div>
                <div className={styles.row3}>
                  {[
                   
                    ['Customer Number',  loadingClient ? 'Loading...' : customerNumber],
                    ['Company',          loadingClient ? 'Loading...' : companyName],
                  ].map(([lbl, val]) => (
                    <div className={styles.field} key={lbl}>
                      <label className={styles.label}>{lbl} <span className={styles.autoBadge}>auto-filled</span></label>
                      <input className={`${styles.input} ${styles.inputReadonly} ${loadingClient ? styles.inputLoading:''}`} value={val} readOnly />
                    </div>
                  ))}
                </div>
                <div className={styles.row2}>
                  <div className={styles.field}>
                    <label className={styles.label}>Contact Name</label>
                    <input className={styles.input} placeholder="Your full name" value={contactName} onChange={e => setContactName(e.target.value)} required />
                  </div>
                  <div className={styles.field}>
                    <label className={styles.label}>Contact Email</label>
                    <input className={styles.input} type="email" placeholder="your@email.com" value={contactEmail} onChange={e => setContactEmail(e.target.value)} required />
                  </div>
                </div>
              </div>
 
              {/* Issue details */}
              <div className={styles.card}>
                <div className={styles.sectionLabel}>Issue Details</div>
                <div className={styles.row1}>
                  <div className={styles.field}>
                    <label className={styles.label}>Subject</label>
                    <input className={styles.input} placeholder="Brief description of the issue" value={subject} onChange={e => setSubject(e.target.value)} maxLength={120} required />
                  </div>
                </div>
                <div className={styles.row2}>
                  <div className={styles.field}>
                    <label className={styles.label}>Category</label>
                    <select className={styles.select} value={category} onChange={e => setCategory(e.target.value)} required>
                      <option value="" disabled>Select a category</option>
                      {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div className={styles.field}>
                    <label className={styles.label}>Affected Area</label>
                    <select className={styles.select} value={area} onChange={e => setArea(e.target.value)}>
                      <option value="" disabled>Select area</option>
                      {AREAS.map(a => <option key={a} value={a}>{a}</option>)}
                    </select>
                  </div>
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Description</label>
                  <textarea className={styles.textarea}
                    placeholder="Describe the issue in detail. Include steps to reproduce, what you expected, and what actually happened."
                    value={description} onChange={e => setDescription(e.target.value)} maxLength={2000} required />
                  <span className={`${styles.charCount} ${charLeft<200?styles.charWarn:''} ${charLeft<0?styles.charOver:''}`}>
                    {description.length} / 2000
                  </span>
                </div>
              </div>
 
              {/* Priority */}
              <div className={styles.card}>
                <div className={styles.sectionLabel}>Priority</div>
                <div className={styles.priorityGrid}>
                  {PRIORITIES.map(p => (
                    <button key={p.key} type="button"
                      className={`${styles.priorityBtn} ${priority===p.key ? styles.priorityBtnActive:''}`}
                      style={priority===p.key ? { borderColor:p.color, color:p.color, background:`${p.color}18` } : {}}
                      onClick={() => setPriority(p.key)}>
                      <span className={styles.priorityDot} style={{ background:p.color }} />{p.label}
                    </button>
                  ))}
                </div>
              </div>
 
              {/* Attachments */}
              <div className={styles.card}>
                <div className={styles.sectionLabel}>Attachments <span className={styles.optional}>(optional)</span></div>
                <div className={styles.dropZone} onClick={() => document.getElementById('fileInput').click()}>
                  <span className={styles.dropIcon}>📎</span>
                  <span className={styles.dropLabel}>Click to attach files</span>
                  <span className={styles.dropHint}>Screenshots, logs, or any relevant files — max 10 MB each</span>
                </div>
                <input id="fileInput" type="file" multiple accept="image/*,.pdf,.txt,.log,.csv" style={{ display:'none' }} onChange={e => handleFiles(e.target.files)} />
                {attachments.length > 0 && (
                  <div className={styles.fileList}>
                    {attachments.map((f,i) => (
                      <div key={i} className={styles.fileChip}>
                        <span>📄</span><span>{f.name}</span>
                        <button type="button" className={styles.fileRemove} onClick={() => setAttachments(prev => prev.filter((_,j)=>j!==i))}>×</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
 
              {formError && <div className={styles.errorBanner}>{formError}</div>}
 
              <div className={styles.formFooter}>
                <span className={styles.footerNote}>All required fields must be completed before submitting.</span>
                <div className={styles.footerActions}>
                  <button type="button" className={styles.btnCancel} onClick={handleReset}>Cancel</button>
                  <button type="submit" className={styles.btnPrimary} disabled={submitting}>
                    {submitting ? 'Submitting...' : 'Submit Ticket →'}
                  </button>
                </div>
              </div>
 
            </form>
          )}
        </>
      )}
 
      {/* ── TAB: MY TICKETS ───────────────────────────────────────────────── */}
      {activeTab === TAB.MY && (
        <div className={styles.myTicketsWrap}>
 
          {/* Filter bar */}
          <div className={styles.filterBar}>
            <span className={styles.filterLabel}>Status:</span>
            <div className={styles.filterBtns}>
              {[
                { val:'',            label:'All'         },
                { val:'open',        label:'Open'        },
                { val:'in_progress', label:'In Progress' },
                { val:'resolved',    label:'Resolved'    },
                { val:'closed',      label:'Closed'      },
              ].map(({ val, label }) => (
                <button key={val}
                  className={`${styles.filterBtn} ${filterStatus===val ? styles.filterBtnActive:''}`}
                  style={filterStatus===val && val ? { borderColor: STATUS_META[val]?.color, color: STATUS_META[val]?.color, background:`${STATUS_META[val]?.color}12` } : {}}
                  onClick={() => setFilterStatus(val)}>
                  {label}
                </button>
              ))}
            </div>
            <button className={styles.refreshBtn} onClick={() => fetchTickets(filterStatus)}>⟳</button>
          </div>
 
          {/* Split layout */}
          <div className={styles.ticketSplit}>
 
            {/* List */}
            <div className={styles.ticketList}>
              {loadingTickets ? (
                <div className={styles.ticketListEmpty}>
                  <div className={styles.loadingSpinner} />
                  Loading tickets...
                </div>
              ) : tickets.length === 0 ? (
                <div className={styles.ticketListEmpty}>
                  <p>No tickets found.</p>
                  <button className={styles.btnPrimary} style={{ marginTop:'12px' }} onClick={() => setActiveTab(TAB.NEW)}>
                    Submit First Ticket
                  </button>
                </div>
              ) : (
                tickets.map(t => {
                  const sm  = STATUS_META[t.status] || STATUS_META.open;
                  const pc  = PRIORITY_COLOR[t.priority] || '#888';
                  const act = selectedTicket?._id === t._id;
                  return (
                    <div key={t._id}
                      className={`${styles.ticketItem} ${act ? styles.ticketItemActive:''}`}
                      onClick={() => setSelectedTicket(t)}>
                      <div className={styles.ticketItemTop}>
                        <span className={styles.ticketNumber}>{t.ticketNumber}</span>
                        <span className={styles.ticketStatus}
                          style={{ color:sm.color, borderColor:`${sm.color}44`, background:`${sm.color}12` }}>
                          {sm.label}
                        </span>
                      </div>
                      <div className={styles.ticketSubject}>{t.subject}</div>
                      <div className={styles.ticketMeta}>
                        <span style={{ color:pc, fontSize:'11px', fontWeight:600 }}>● {t.priority?.toUpperCase()}</span>
                        <span className={styles.ticketDate}>{new Date(t.createdAt).toLocaleDateString()}</span>
                      </div>
                      <div className={styles.ticketCategory}>{t.category}</div>
                    </div>
                  );
                })
              )}
            </div>
 
            {/* Detail + chat */}
            <div className={styles.ticketDetail}>
              {!selectedTicket ? (
                <div className={styles.ticketDetailEmpty}>
                  <span style={{ fontSize:'40px' }}>🎫</span>
                  <p>Select a ticket to view details</p>
                </div>
              ) : (
                <>
                  <div className={styles.detailHeader}>
                    <div>
                      <div className={styles.detailTicketNum}>{selectedTicket.ticketNumber}</div>
                      <div className={styles.detailSubject}>{selectedTicket.subject}</div>
                    </div>
                    <span className={styles.detailStatus}
                      style={{
                        color:       STATUS_META[selectedTicket.status]?.color,
                        borderColor:`${STATUS_META[selectedTicket.status]?.color}44`,
                        background: `${STATUS_META[selectedTicket.status]?.color}12`,
                      }}>
                      {STATUS_META[selectedTicket.status]?.label}
                    </span>
                  </div>
 
                  <div className={styles.detailGrid}>
                    {[
                      ['Category',  selectedTicket.category],
                      ['Area',      selectedTicket.area || '—'],
                      ['Priority',  selectedTicket.priority?.toUpperCase()],
                      ['Submitted', new Date(selectedTicket.createdAt).toLocaleString()],
                      ['Assigned',  selectedTicket.assignedTo || 'Pending'],
                    ].map(([k,v]) => (
                      <div key={k} className={styles.detailGridItem}>
                        <span className={styles.detailGridKey}>{k}</span>
                        <span className={styles.detailGridVal}
                          style={k==='Priority' ? { color:PRIORITY_COLOR[selectedTicket.priority] } : {}}>
                          {v}
                        </span>
                      </div>
                    ))}
                  </div>
 
                  {/* Chat thread */}
                  <div className={styles.chatSection}>
                    <div className={styles.chatLabel}>💬 Ticket Thread</div>
                    <div className={styles.chatMessages}>
 
                      {/* Original message */}
                      <div className={styles.chatMsgClient}>
                        <div className={`${styles.chatBubble} ${styles.chatBubbleClient}`}>
                          <div className={styles.chatBubbleHeader}>
                            <span className={styles.chatAuthor}>{selectedTicket.contactName}</span>
                            <span className={styles.chatTime}>{new Date(selectedTicket.createdAt).toLocaleString()}</span>
                          </div>
                          <div className={styles.chatBubbleText}>{selectedTicket.description}</div>
                        </div>
                      </div>
 
                      {/* Notes */}
                      {(selectedTicket.notes || []).map((note, i) => (
                        <div key={i} className={note.isClient ? styles.chatMsgClient : styles.chatMsgSupport}>
                          <div className={`${styles.chatBubble} ${note.isClient ? styles.chatBubbleClient : styles.chatBubbleSupport}`}>
                            <div className={styles.chatBubbleHeader}>
                              <span className={styles.chatAuthor}>{note.addedBy || 'Support'}</span>
                              <span className={styles.chatTime}>{new Date(note.addedAt).toLocaleString()}</span>
                            </div>
                            <div className={styles.chatBubbleText}>{note.text}</div>
                          </div>
                        </div>
                      ))}
                      <div ref={chatEndRef} />
                    </div>
 
                    {['resolved','closed'].includes(selectedTicket.status) ? (
                      <div className={styles.chatClosed}>
                        This ticket is {selectedTicket.status}. Submit a new ticket if the issue persists.
                      </div>
                    ) : (
                      <div className={styles.chatInputRow}>
                        <input
                          className={styles.chatInput}
                          placeholder="Add a message or update..."
                          value={chatMsg}
                          onChange={e => setChatMsg(e.target.value)}
                          onKeyDown={e => { if (e.key==='Enter' && !e.shiftKey) { e.preventDefault(); handleChatSend(); } }}
                        />
                        <button className={styles.chatSendBtn} onClick={handleChatSend} disabled={!chatMsg.trim()}>
                          Send →
                        </button>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
 
          </div>
        </div>
      )}
    </div>
  );
};
 
export default ITTicketPage;